export enum DocumentFileTypeEnum {
  DICOM_IMAGE = '0000001B-1000-0000-0000-000000000001',
  FOLDER      = '0000001B-1000-0000-0000-000000000002',
  JPG         = '0000001B-1000-0000-0000-000000000003',
  PHOTOSHOP   = '0000001B-1000-0000-0000-000000000004',
  WordDoc     = '0000001B-1000-0000-0000-000000000005',
  Excel       = '0000001B-1000-0000-0000-000000000006',
  PowerPoint  = '0000001B-1000-0000-0000-000000000007',
  JSON        = '0000001B-1000-0000-0000-000000000008',
  XML         = '0000001B-1000-0000-0000-000000000009',
  PDF         = '0000001B-1000-0000-0000-000000000010',
  AVI         = '0000001B-1000-0000-0000-000000000011',
  MP3         = '0000001B-1000-0000-0000-000000000012',
  MP4         = '0000001B-1000-0000-0000-000000000013',
  WAV         = '0000001B-1000-0000-0000-000000000014',
}
